import React, { useEffect } from 'react';
import { useState } from 'react';
import { Divider, Form, Radio, CheckBox, Icon } from '@roo/roo';
import detail from './mock';
import { renderDetailByColumns, renderDetailListByColumns, renderFile } from '../scientist/util';
import '../index.scss';

const cols = { field: { span: 9, offset: 0, }, label: { span: 3 } };

const propertyColumns = [{
    label: '产权类别',
    key: 'propertyName'
}, {
    label: '产权名称',
    key: 'propertyType'
}, {
    label: '产权编号',
    key: 'applyNumber'
}, {
    label: '知识产权文件上传',
    key: 'fileUrl',
    layout: 'vertical',
    _render: (item) => renderFile(item, 'fileUrl')
}];

const honorColumns = [{
    label: '获奖时间',
    key: 'honorTime'
}, {
    label: '奖项名称',
    key: 'honorName'
}, {
    label: '项目名称',
    key: 'honorProjectName',
}, {
    label: '等级排名',
    key: 'honorRank'
}, {
    label: '授奖机构',
    key: 'honorInstitution'
}, {
    label: '证书上传',
    key: 'fileUrl',
    layout: 'vertical',
    _render: (item) => renderFile(item, 'fileUrl')
}]

export default ({detail}) => {
    const { propertyInfo, honorInfo, otherCredentials } = detail;
    return (
        <>
            <h3 id="property" className='catalogue-tag'>知识产权情况</h3>
            <Divider />
            {
                renderDetailListByColumns(propertyInfo, propertyColumns, cols)
            }
            <h3 id="honor" className='catalogue-tag'>机构所获荣誉</h3>
            <Divider />
            {
                renderDetailListByColumns(honorInfo, honorColumns, cols)
            }
            <h3 id="other" className='catalogue-tag'>其他附件及证明文件</h3>
            <Divider />
            <div className='preview-item-wrap'>
                <div className='preview-item-wrap-withoutbackground preview-item-other-credentials'>
                    <Form cols={cols}>
                        <Form.Field layout='vertical'>
                            {renderFile(otherCredentials)}
                        </Form.Field>
                    </Form>
                </div>
            </div>
        </>
    )
}